exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.red-packet-container[data-v-58ad9c0d] {\n  padding: 20px;\n  height: 100%;\n}\n\n", ""]);

// exports
